export default "__VITE_PUBLIC_ASSET__b566d0a3__"